module.exports = __webpack_public_path__ + "img/logo.396e7288.png";